import { Component, OnInit, ViewChild } from '@angular/core';
import { CrosstrendService } from 'src/app/services/crosstrend.service';
import * as Highcharts from 'highcharts';
import { TradingSystemSummary } from 'src/app/models/trading-system-summary';
import { TradingSystemGraficoWeeklyComponent } from '../../shared/trading-system-grafico-weekly/trading-system-grafico-weekly.component';
//import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { ModalGraphComponent } from '../../shared/modal-graph/modal-graph.component';
import { CommonModule } from '@angular/common';
import { HighchartsChartModule } from 'highcharts-angular';
import { TradingSystemSummaryComponent } from '../../shared/trading-system-summary/trading-system-summary.component';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
declare global {
  interface Window {
    aprimodal: any;
  }
}
@Component({
  selector: 'app-backtest-h1',
  standalone: true,
  templateUrl: './backtest-h1.component.html',
  styleUrls: ['./backtest-h1.component.scss'],
  imports: [
    TradingSystemGraficoWeeklyComponent, CommonModule,
    HighchartsChartModule, TradingSystemGraficoWeeklyComponent,
    TradingSystemSummaryComponent, MdbSelectModule
  ]
})
export class BacktestH1Component implements OnInit {

  chartOptions: Highcharts.Options = {}
  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor: string = 'chart';
  updateFlag: boolean = false; // optional boolean
  oneToOneFlag: boolean = true; // optional boolean, defaults to false
  runOutsideAngular: boolean = false; // optional boolean, defaults to false
  runOutsideAngularFlag = false; // optional boolean, defaults to false

  mercati: any[] = []
  selezionato: string = ''
  ts!: TradingSystemSummary
  @ViewChild('chartWeek') chartWeek!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartBuy') chartWeekBuy!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartSell') chartWeekSell!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartMonth') chartMonth!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartMonthlyBuy') chartMonthlyBuy!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartMonthlySell') chartMonthSell!: TradingSystemGraficoWeeklyComponent
  //modalRef: MdbModalRef<ModalGraphComponent> | null = null;

  constructor(private serv: CrosstrendService,
    //private modalService: MdbModalService
  ) { }

  ngOnInit(): void {
    this.serv.listaMercati().subscribe((data: any) => {
      console.log(data)
      this.mercati = data.data.filter((el: any) => el.tipo == 'Major' || el.tipo == 'Cross')
    })    
    window.aprimodal = this.openModal;
  }

  openModal(tableData: any, graphData: any, that: any,title: string,id: any) {
    that.modalRef = that.modalService.open(ModalGraphComponent, {
      data: {
        tableData: [tableData],
        graphData: graphData,
        title: title,
        params: {mkt: that.selezionato,id: id, timeframe: 'h1'}
      },
      modalClass: 'modal-dialog-centered modal-xl'
    })
  }

  cambiaMercato(market: string) {
    this.selezionato = market
    this.serv.listaCrossTrendH1(market).subscribe((data: any) => {
      console.log(data)
      if (data.res == 'ok') {
        //data.data.map((el: any) => { el.punti = el.profit })
        this.chartWeek.caricaDati(data.data)
        this.chartWeekBuy.caricaDati(data.data.filter((el: any) => el.verso == 'buy'))
        this.chartWeekSell.caricaDati(data.data.filter((el: any) => el.verso == 'sell'))
        this.chartMonth.caricaDatiMese(data.data)
        this.chartMonthlyBuy.caricaDatiMese(data.data.filter((el: any) => el.verso == 'buy'))
        this.chartMonthSell.caricaDatiMese(data.data.filter((el: any) => el.verso == 'sell'))
        this.ts = new TradingSystemSummary().popolaDati(market, this.mercati.find((el: any) => el.market == market).pip, data.data)
        this.ts.spread = this.mercati.find((el: any) => el.market == market).spread
        this.aggiornaGrafico(data.data)
      }
    })
  }

  aggiornaGrafico(data: any) {
    let s1 = data.map((el: any) => [el.ora, el.prog])
    let s2 = data.map((el: any) => [el.ora, parseFloat(el.close)])
    var that = this
    this.chartOptions = {
      title: {
        text: 'Backtest H1'
      },
      chart: {
        zooming: {
          type: 'x'
        }
      },
      series: [{
        name: 'Progressivo',
        data: s1,
        type: 'line',
        color: 'lime',
      }, {
        name: this.selezionato,
        data: s2,
        type: 'line',
        dashStyle: 'ShortDot',
        yAxis: 1
      }],
      yAxis: [
        {
          title: {
            text: 'Progressivo'
          }
        },
        {
          title: {
            text: 'Cambio'
          },
          opposite: true
        }
      ],
      plotOptions: {
        series: {
          events:  {
            click: function (event) {
              /* alert(
                JSON.stringify(data[event.point.x])
              ); */
              //var that = this
              window.aprimodal(data[event.point.x], s2, that, 'Operazione numero ' + event.point.x, event.point.x)              
            }
          }
        }
      },
    }
    this.updateFlag = true
  }

}
